import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDayLightClouds: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M36.0658 46.2889C37.7658 42.2556 40.5547 38.8778 43.977 36.3111C41.7436 32.0667 37.3436 29.1334 32.2103 29.1334C24.8436 29.1334 18.877 35.1 18.877 42.4667C18.877 46.6111 20.8103 50.2667 23.777 52.7111C26.877 49.2667 31.1881 46.8889 36.0658 46.2889Z"
        fill="#F9D23E"
      />
      <path d="M34.2207 15.8H30.2207V25.8H34.2207V15.8Z" fill="#F9D23E" />
      <path
        d="M14.7819 22.1965L11.9531 25.0249L19.0241 32.0969L21.8529 29.2685L14.7819 22.1965Z"
        fill="#F9D23E"
      />
      <path
        d="M15.5547 40.4667H5.55469V44.4667H15.5547V40.4667Z"
        fill="#F9D23E"
      />
      <path
        d="M49.6657 22.1963L42.5957 29.2683L45.4245 32.0963L52.4945 25.0243L49.6657 22.1963Z"
        fill="#F9D23E"
      />
      <path
        d="M21.6995 55.5111L19.0217 52.8334L11.9551 59.9112L14.7773 62.7334L21.3884 56.1334L21.8551 55.6667L21.6995 55.5111Z"
        fill="#F9D23E"
      />
      <path
        d="M84.2882 60.4556H79.2104V55.5112C79.2104 44.6001 70.1104 35.7556 58.8882 35.7556C53.666 35.7556 48.9771 37.7223 45.3993 40.8778C42.4993 43.4334 40.3104 46.7556 39.2993 50.5667H38.5771C34.3438 50.5667 30.5104 52.2556 27.7549 54.9667C25.0326 57.6445 23.3438 61.3223 23.3438 65.3778C23.3438 73.5556 30.166 80.1889 38.5771 80.1889H43.6549H74.1326H84.2882C89.8993 80.1889 94.4438 75.7667 94.4438 70.3112C94.4438 64.8667 89.8993 60.4556 84.2882 60.4556Z"
        fill="#D2E0FF"
      />
    </svg>
  )
}

export default WeatherIconDayLightClouds
